import { render, staticRenderFns } from "./rate-regions-table.vue?vue&type=template&id=1c16d628&scoped=true"
import script from "./rate-regions-table.vue?vue&type=script&lang=js"
export * from "./rate-regions-table.vue?vue&type=script&lang=js"
import style0 from "./rate-regions-table.vue?vue&type=style&index=0&id=1c16d628&prod&lang=scss&scoped=true"
import style1 from "./rate-regions-table.vue?vue&type=style&index=1&id=1c16d628&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c16d628",
  null
  
)

export default component.exports